import { RankingInvestigadorPeriodoDTO, RankingUnidadesPeriodoDTO } from '../types/Ranking';
import { store } from '../../../redux/store';

const SERV_BACK: string = process.env.REACT_APP_BACK || '';

export default class ConsultasService {


    public static async Account(
        id: string,
        netid: string
    ) {
        try {
            const url = `${SERV_BACK}/api/Account/`;
            const payload = { "idapp": id, "netid": netid }
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.title || `Error en la petición: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error en PostPeriodoRanking:", error);
            throw error;
        }
    }

    public static async PostPeriodoRanking(
        id: number,
        payload: RankingInvestigadorPeriodoDTO
    ) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/PostPeriodoRanking/${id}`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.title || `Error en la petición: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error en PostPeriodoRanking:", error);
            throw error;
        }
    }

    public static async PostRankingUnidades(
        id: number,
        payload: RankingUnidadesPeriodoDTO
    ) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/PostRankingUnidades/${id}`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.title || `Error en la petición: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error en PostPeriodoRanking:", error);
            throw error;
        }
    }

    public static async GetRankingPeriodoPorId(id: number) {
        const state = store.getState();
        const token = state.authReducer.token;

        try {
            const url = `${SERV_BACK}/api/Profesores/PostPeriodoRanking/${id}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.title || `Error en la petición: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingPeriodoPorId:", error);
            throw error;
        }
    }

    public static async GetFechasCreacionByYear(anio: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetFechasCreacionByYear/${anio}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        }
        catch (error) {
            console.error("Error en GetFechasCreacionByYear:", error);
            throw error;
        }

    }

    public static async GetCentrosUnidadesFechasCreacionByYear(anio: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetCentrosUnidadesFechasCreacionByYear/${anio}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        }
        catch (error) {
            console.error("Error en GetFechasPorAño:", error);
            throw error;
        }

    }

    public static async ActivarPeriodoRanking(id: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/ActivarPeriodoRanking/${id}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        }
        catch (error) {
            console.error("Error en ActivarPeriodoRanking:", error);
            throw error;
        }

    }

    public static async ActivarCentrosRanking(id: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/ActivarCentrosRanking/${id}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        }
        catch (error) {
            console.error("Error en ActivarPeriodoRanking:", error);
            throw error;
        }

    }

    public static async GetRankingAreasActivas() {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingAreasActivas`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingAreasActivas:", error);
        }
    }

    public static async GetRankingByPeriodoAndArea(id: number, area: string) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingByPeriodoAndArea/${id}/${area}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingByPeriodoAndArea:", error)
        }
    }

    public static async GetRankingOffical(tipoCargo: string, area: string) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingOffical/${tipoCargo}/${area}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingOffical:", error)
        }
    }

    public static async GetRankingUnidadesOffical() {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingUnidadesOffical`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingUnidadesOffical:", error)
        }
    }

    public static async GetRankingSubAreasActivas(id: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingSubAreasActivas/${id}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetSubRankingByPeriodo:", error)
        }
    }

    public static async GetCuartilConArea(cuartil: string, id: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetCuartilConArea/${cuartil}/${id}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetSubRankingByPeriodo:", error)
        }
    }

    public static async GetColabInternacional(id: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetColabInternacional/${id}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetSubRankingByPeriodo:", error)
        }
    }

    public static async GetColabInternacionalOficial() {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetColabInternacionalOficial`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetSubRankingByPeriodo:", error)
        }
    }

    public static async GetRankingUnidades(id: number) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingUnidades/${id}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingUnidades:", error)
        }
    }

    public static async GetRankingUnidadesByType(id: number, tipo: string) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingUnidadesByType/${id}/${tipo}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingUnidadesByType:", error)
        }
    }

    public static async GetRankingUnidadesOfficialByType(tipo: string) {
        const state = store.getState();
        const token = state.authReducer.token;
        try {
            const url = `${SERV_BACK}/api/Profesores/GetRankingUnidadesOfficialByType/${tipo}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error en GetRankingUnidadesOfficialByType:", error)
        }
    }
}